import { $getSelection, $isRangeSelection, RangeSelection, TextNode } from 'lexical';

import { NodeType } from './parser';

export const $getSelectedNode = () => {
  const sel = $getSelection();

  // If there’s no selection, or if it’s a range (not collapsed), do nothing
  if (!$isRangeSelection(sel) || !sel.isCollapsed()) return null;

  return sel.anchor.getNode() as InstanceType<NodeType>;
};

export const collectNodes = (node: TextNode) => (function* () {
  let n = node;
  while (n) {
    yield n;
    n = n.getNextSibling();
  }
})();

export const getSelectionEdges = (selection: RangeSelection) => {
  const isBackward = selection.isBackward();
  const anchor = isBackward ? selection.focus : selection.anchor;
  const focus = isBackward ? selection.anchor : selection.focus;
  return [anchor, focus];
};